import { RichText } from "@ui/eva-components/RichText";
import classNames from "classnames";

import { Container } from "@jti/core-components/components/Container";

import styles from "./HealthBanner.module.scss";

export type HealthBannerProps = {
  variant?: "default" | "strong" | "stronger" | "custom";
  backgroundColor?: string;
  textColor?: string;
  fontSize?: string;
  fontFamily?: string;
  borderColor?: string;
  borderWidth?: string;
  width?: string;
  height?: string;
  content?: string;
  noPadding?: boolean;
};

export const HealthBanner = ({
  content,
  variant = "default",
  backgroundColor,
  borderColor,
  borderWidth,
  fontFamily,
  fontSize,
  textColor,
  width,
  height,
  noPadding,
}: HealthBannerProps) => (
  <div
    data-testid="healthBanner"
    className={classNames(
      {
        "light-theme": variant !== "default",
      },
      styles.wrapper,
      styles[variant]
    )}
    style={{
      "--custom-health-banner-background-color": backgroundColor,
      "--custom-health-banner-text-color": textColor,
      "--custom-health-banner-font-size": fontSize,
      "--custom-health-banner-font-family": fontFamily,
      "--custom-health-banner-border-color": borderColor,
      "--custom-health-banner-border-width": borderWidth,
      "--custom-health-banner-width": width,
      "--custom-health-banner-height": height,
    }}
  >
    <div className={classNames(styles.innerWrapper, { [styles.noPadding]: noPadding })}>
      <Container className={styles.container}>
        <div className={classNames(styles.healthBannerContainer)} data-testid="footerHealthBanner">
          <RichText
            className={classNames(styles.healthBannerContent, { [styles.customFontSizeDefinition]: fontSize })}
            content={content ?? ""}
          />
        </div>
      </Container>
    </div>
  </div>
);
